<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="title order_title"><i>订单信息</i><i>{{form.orderStatusCn}}</i></p>
          <div class="totals-box order-boxs">
            <div class="detail">
              <div class="customTable">
                <div class="box">
                  <div class="itemName">订单编号</div>
                  <div class="itemNum">{{ form.id }}</div>
                </div>
                <div class="box">
                  <div class="itemName">下单顾客</div>
                  <div class="itemNum">{{ form.customerName }}</div>
                </div>
                <div class="box">
                  <div class="itemName">下单时间</div>
                  <div class="itemNum">{{ formatDate(form.orderTime) }}</div>
                </div>
                <div class="box">
                  <div class="itemName">订单来源</div>
                  <div class="itemNum">{{ form.orderSourceCn }}</div>
                </div>
                <div class="box" v-if="form.orderStatus !== 'waitPay'">
                  <div class="itemName">支付方式</div>
                  <div class="itemNum">{{ form.payWayCn }}</div>
                </div>
                <div class="box" v-if="form.orderStatus !== 'waitPay'">
                  <div class="itemName">支付时间</div>
                  <div class="itemNum">{{ formatDate(form.oxLtime) }}</div>
                </div>
              </div>
            </div>
          </div>

          <p class="title order-title-boxs">订单明细</p>
          <div class="totals-box">
            <div class="detail">
              <div class="customTable">
                <div  v-for="(item,index) in form.orderItemVOList" :key="index" style="border-bottom: 1px solid #eee;">
                  <div class="box_flex mb10">
                    <div class="itemName">{{ item.itemName }}</div>
                    <div class="box_flex1">
                      <div class="itemNum item_num" style="padding: 0 30px;">x{{ item.itemNum }}</div>
                      <div class="item-else">
                        <div style="color: #e02020;">￥{{ item.realPayAmount }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="box_flex mb10">
                    <div>技师</div>
                    <div>{{item.staffNames}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p class="title order-title-boxs">订单金额</p>
          <div class="totals-box order-boxs">
            <div class="detail">
              <div class="customTable">
                <div class="box">
                  <div class="itemName">总金额</div>
                  <div class="itemNum">￥{{ form.orderAmount }}</div>
                </div>
                <div class="box">
                  <div class="itemName">总数量</div>
                  <div class="itemNum">{{ form.itemNum }}</div>
                </div>
                <div class="box">
                  <div class="itemName">折扣金额</div>
                  <div class="itemNum money decoration">￥{{ form.discountAmount }}</div>
                </div>
                <div class="box">
                  <div class="itemName">实际支付金额</div>
                  <div class="money">￥{{ form.realPayAmount }}</div>
                </div>
              </div>
            </div>
          </div>

          <p class="title org-title">提成信息</p>
          <div class="totals-box customTable">
            <div class="detail">
              <el-table :data="form.achievementVOList" input-large>
                <el-table-column prop="staffName" label="店员姓名" min-width="auto"></el-table-column>
                <el-table-column prop="itemName" label="商品信息" min-width="auto" width="auto"></el-table-column>
                <el-table-column prop="achievementTotalAmount" label="业绩" width="auto">
                    <template slot-scope="scope">
                        ￥{{scope.row.achievementTotalAmount.toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="deductTotalAmount" label="提成" width="auto">
                    <template slot-scope="scope">
                        ￥{{scope.row.deductTotalAmount.toFixed(2)}}
                    </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

        </div>
        <div class="drawer-footer">
          <div class="back el-icon-back" @click="back"></div>
        </div>
      </div>
    </drawer>
   
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";

import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: {
    drawer
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "订单详情",
      form: {
        orderType: ""
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.$api
          .get(this.$url.orderInfo.get, {
            id: org
          })
          .then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.form.orderTime = this.formatDate(this.form.orderTime);
              this.form.payTime = this.formatDate(this.form.payTime);
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
            }
          }).catch(error => {})
      });
    },
    handleChange(bool) {
      this.addEditShow = false;
      this.$emit("change", true);
    },
    back() {
      this.addEditShow = false;
      this.$emit("change", true);
    },
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  border-top: 10px solid @borderColor;
  border-bottom: 10px solid @borderColor;
  .titles-head {
    border-top: 0;
  }
  .totals-box {
    // padding: 0.2rem 0;
    .customTable {
      .box_flex1 {
        display: flex;
        align-items: center;
      }
      .item_line {
        text-decoration: line-through;
      }
      .item_num {
        color: @999;
      }
      .box_flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 26px;
      }
      .box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 72px;
        padding: 15px 26px;
        box-sizing: border-box;
        color: #8d8d8d;
        border-bottom: 1px solid @borderColor;
        .item-else {
          display: flex;
        }
        .money {
          margin-left: 60px;
          color: @money;
        }
      }
    }
    .detail {
      padding: 0;
      font-size: 1rem;
      .rows {
        margin-bottom: 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        p {
          &:first-child {
            min-width: 90px;
          }
          &:last-child {
            text-align: right;
          }
        }
        .amount {
          font-size: 0.3rem;
        }
        div {
          color: #ff892a;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .order-title-boxs {
    border-top: 10px solid @borderColor;
  }
  .order-boxs {
    .customTable {
      .box {
        height: 46px;
        .decoration {
          text-decoration: line-through;
        }
        .itemNum {
          font-size: 18px;
        }
        .itemName {
          color: #333;
        }
      }
    }
  }
  .order_title {
    display: flex;
    justify-content: space-between;
    padding-right: 26px;
    i {
      font-style: normal;
      &:last-child {
        color: #8d8d8d;
      }
    }
  }
  .org-title {
    border-top: 10px solid @borderColor;
  }
  .pay-methods {
    padding: 0.3rem;
    .methods {
      margin-right: 0.2rem;
      width: 138px;
      height: 108px;
      background-color: #ececed;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgs {
        margin-bottom: 0.1rem;
        width: 30px;
        height: 30px;
      }
    }
  }
}
.dialog-staff-box {
  .body-content {
    .deduct-amount {
      display: flex;
      justify-content: space-between;
      margin: 0 30px;
      font-size: 16px;

      .money {
        color: #f40;
      }
    }
    .body-title {
      text-align: right;
      color: #2795fd;
      cursor: pointer;
      i {
        margin-right: 9px;
      }
    }
    .boxs {
      margin: 0 29px;
      font-size: 16px;
      .box {
        margin-top: 20px;
        background-color: #f3f3f3;
        border-radius: 4px;
        color: #282828;
        display: flex;
        align-items: center;
        .flex {
          flex: 1;
          margin-right: 42px;
          .staffs-msg {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            // align-items: center;
            .img {
              cursor: pointer;
            }
            .staff-name {
              display: flex;
              align-items: center;
            }
            .add-img {
              width: 35px;
              vertical-align: middle;
              position: relative;
              &::before {
                content: "+";
                position: absolute;
                font-size: 24px;
                height: 35px;
                top: 0;
                left: 0;
                width: 35px;
                text-align: center;
              }
            }
            .notStaff {
              position: relative;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              width: 133px;
              height: 33px;
              cursor: pointer;
              display: flex;
              justify-content: center;
              .span {
                left: 45px;
                position: absolute;
                height: 33px;
                display: flex;
                align-items: center;
                &::before {
                  content: "+";
                  font-size: 24px;
                  position: absolute;
                  left: -20px;
                  color: #333;
                  height: 35px;
                  top: 0;
                }
              }
            }
          }
          .deduct-msg {
            padding: 20px 0;
            display: flex;
            justify-content: space-between;
          }
          .label {
            margin-left: 26px;
          }
        }
        .close {
          margin-right: 20px;
          font-size: 25px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>